import { Platform } from 'react-native';

/**
 *
 * @returns true if Platform is 'ios', 'macos'
 */
export const isAppleDevice = () => {
  return Platform.OS === 'ios' || Platform.OS === 'macos';
};
